import type { FaireProductEntity } from "../../entity_types/product";

export const p_kkbnze4d8x: FaireProductEntity = {
  token: "p_kkbnze4d8x",
  type: "product",
  name: '50 4x6" Thank You Order Cards - You’ve Got Great Taste',
  brandToken: "b_e4kpbeuvwn",
  brandName: "T Marie",
  imageUrl:
    "https://cdn.faire.com/fastly/04b31ce2f38de3dec9d739e8471ab10c9e76e97784db88b5469d6f06cd4fde41.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/7808edd2ee1247f5f9ec962edd11bea902faefdbd02e7b0597f08e10421c2ef1.jpeg",
    "https://cdn.faire.com/fastly/f2bce8adb8b2699222dcedff21a4d158c82f484593e69ff3d495272bfcde257a.jpeg",
    "https://cdn.faire.com/fastly/2e1e2c5f9a9ec75c4268fe682c75a293b452a055828834133ca18d7c02ffcb9f.jpeg",
    "https://cdn.faire.com/fastly/cdb79a037d162246b61ee0dfd889d4c4055829d5ff456f3d4aa0da227dd15d13.jpeg",
    "https://cdn.faire.com/fastly/44b00a5ebe80aa3896f1a747018d8586c4cdc5e1182533f5132d2be7c549ebc2.jpeg",
  ],
  priceDollars: 6.45,
  description:
    "• Each unit includes 50 postcards of the same design\n• 4x6” uncoated both sides\n• Postcards come shrink wrapped together as a set of 50\n\nMake Customers Feel Good About Their Orders!\n\nSometimes it’s those small personal touches that really make an impression on customers. And when it comes to unboxing an order in the mail, it’s the perfect opportunity to really wow your customers! That’s how you and create buzz and inspire loyal, long-term buyers.\n\nCustomers will love the warm, playful message on these cards - a subtle compliment to boost their self esteem and make them feel good about their order! We leave plenty of space on the card for you to add your own personalized message or signature. Some business owners like to stamp their business info at the bottom, or add a logo sticker to the back of the cards.\n\nOur thank you cards can be shared in so many ways. Sales reps use them as notecards and send them in the mail.",
  tags: [],
  msrpDollars: 12.9,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:49:22.855Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
